module.exports = __webpack_public_path__ + "static/media/3560.eba44d6c.jpg";